export const initStateCatalogueTypeDocuments = (
   Object.assign({
      data                          : [],
      items_selected                : [],
      document_name_spanish         : '',
      document_name_english         : '',
      legend_footer_spanish         : '',
      legend_footer_english         : '',
      actionForm                    : false,
      typeDocumentId                : '',
      selectOptionCategoryDocument  : '',
      general_concepts_selected     : [],
      serie_folio                   : '',
      concepts_discount_selected    : []
   })
);